import React from "react";
import { Card } from "@/components/ui/card";

// Key race distances in miles
const DISTANCES = [
  { label: "1 mi", mi: 1 },
  { label: "5K", mi: 3.107 },
  { label: "10K", mi: 6.214 },
  { label: "10 mi", mi: 10 },
  { label: "Half", mi: 13.109 },
  { label: "Marathon", mi: 26.219 },
];

// Paces from 5:00 to 15:00 min/mi in 30s steps
const PACES = [];
for (let s = 300; s <= 900; s += 30) PACES.push(s);

const fmtPace = (sec) => `${Math.floor(sec / 60)}:${String(sec % 60).padStart(2, "0")}`;

const fmtTime = (totalSec) => {
  const t = Math.round(totalSec);
  const h = Math.floor(t / 3600);
  const m = Math.floor((t % 3600) / 60);
  const s = t % 60;
  if (h > 0) return `${h}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  return `${m}:${String(s).padStart(2, "0")}`;
};

export const PaceChart = () => {
  return (
    <div className="pb-28" data-testid="pace-chart">
      <h3 className="font-display text-lg font-bold mb-1">Race pace chart</h3>
      <p className="text-muted-foreground text-sm mb-4">Finish times by pace (min/mile) across common distances.</p>
      <Card className="rounded-2xl bg-card border-border p-0 overflow-hidden">
        <div className="overflow-x-auto rd-scrollbar">
          <table className="w-full text-sm border-collapse">
            <thead>
              <tr className="border-b border-border">
                <th className="sticky left-0 z-10 bg-card text-left px-3 py-2.5 font-semibold text-[#ccff0c] whitespace-nowrap">Pace</th>
                {DISTANCES.map((d) => (
                  <th key={d.label} className="px-3 py-2.5 font-semibold text-muted-foreground text-right whitespace-nowrap">{d.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {PACES.map((p, i) => (
                <tr key={p} data-testid={`pace-row-${p}`} className={`border-b border-border ${i % 2 ? "bg-white/[0.02]" : ""}`}>
                  <td className="sticky left-0 z-10 bg-popover px-3 py-2 font-mono font-bold text-[#ccff0c] whitespace-nowrap">{fmtPace(p)}</td>
                  {DISTANCES.map((d) => (
                    <td key={d.label} className="px-3 py-2 text-right font-mono text-muted-foreground whitespace-nowrap">{fmtTime(p * d.mi)}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
      <p className="text-muted-foreground text-xs mt-3 text-center">Paces 5:00 → 15:00 /mi · 1 mile to full marathon (26.2 mi)</p>
    </div>
  );
};

export default PaceChart;
